/*
 * Copyright (c) 2023. Vitalii Kozyr
 */

package core.domain

class NetworkException : ApiException(message = "Network error.")